import { post } from './http';
import { dataLayerAddToCart } from './Gtm.service';

export const add = async ({ articleNumber, quantity = 1 }) => {
    if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
        throw 'Invalid quantity';
    }

    const response = await post('/api/cart/add', {
        articleNumber,
        quantity: parseFloat(quantity),
    });
    var result = await response.json();

    try {
      addToDataLayer([{articleNumber, quantity}], result.orderRows);
    } catch (err) { }
  
    return result;
  };

export const reorder = async (orderId) => {
    const response = await post('/api/cart/reorder', { orderId });
    return response.json();
};

export const reorderSample = async (orderId) => {
    const response = await post('/api/cart/reorder', { orderId });
    return response.json();
};

const addToDataLayer = (products, orderRows) => {
    let responseProducts = [];
    
    orderRows.map((row) => {
      for (const i in products) {
        if (Object.hasOwnProperty.call(products, i)) {
          if (products[i].articleNumber === row.articleNumber) {
            const index = responseProducts.findIndex(e => e.articleNumber === row.articleNumber);
    
            if (index === -1) {
              row.gtmEcommerceItem.quantity = products[i].quantity;
              row.gtmEcommerceItem.index = responseProducts.length;
              responseProducts.push(row);
            }
          }
        }
      }
    });
  
    const gtmEcommerceItems = responseProducts.map(p => p.gtmEcommerceItem);
    if (gtmEcommerceItems) {
      dataLayerAddToCart(gtmEcommerceItems);
    }
  }
